<template>
  <div ref="libraryItem" :class="['gd-library-item-container', 'gd-library-item-draggable', `gd-library-item-type-${itemType}`]" :data-itemid="libraryItemId" @click="itemClicked">
    <div class="gd-library-item-thumb">
      <i v-if="icon && !thumbnailData" :class="['fal', icon, iconClass, 'fa-fw', 'gd-library-item-icon']"></i>
      <img v-if="thumbnailData" :src="thumbnailData" class="gd-library-item-thumbnail" />
    </div>
    <div class="gd-library-item-text-area">
      <div class="gd-library-item-title">{{title}}</div>
      <div class="gd-library-item-description">{{description}}</div>
      <div class="gd-library-item-contact-info" v-if="linkedContactCount > 0">
        <LabelBadge labelClass="label-customer">{{linkedContactCount}} Contact{{displayCountPlural(linkedContactCount)}}</LabelBadge>
      </div>
      <div class="gd-library-item-label-area">
        <LabelTags :labelList="labelList" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$editor-library-item-size: 80px;
$editor-library-item-thumbsize: 60px;

.gd-library-item-container {
  cursor: pointer;
  position: relative;
  display: flex;
  width: 100%;
  height: $editor-library-item-size;
  margin: 6px 0px;
  background-color: #616264;
  color: #e4e4e7;
  border-left: 5px solid #000000;
  border-top: 1px solid #5C6073;
  border-right: 1px solid #5C6073;
  border-bottom: 1px solid #5C6073;
  overflow: clip;
}
.gd-library-item-thumb {
  width: $editor-library-item-thumbsize;
  height: calc(#{$editor-library-item-size} - 10px);
  margin-top: 4px;
  margin-left: 4px;
  background-color: #3B3A3F;
  vertical-align: middle;
  line-height: calc(#{$editor-library-item-size} - 10px);
}
.gd-library-item-text-area {
  position: relative;
  flex: 1;
  padding-left: 4px;
}
.gd-library-item-contact-info {
  position: absolute;
  left: 4px;
  bottom: 4px;
  max-width: 100%;
  overflow-x: clip;
  white-space: nowrap;
}
.gd-library-item-label-area {
  position: absolute;
  right: 0px;
  bottom: 4px;
  max-width: 100%;
  overflow-x: clip;
  white-space: nowrap;
}
.gd-library-item-title {
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gd-library-item-description {
  text-align: left;
  font-size: 12px;
  white-space: pre;
}
.gd-library-item-icon {
  text-align: center;
  width: $editor-library-item-thumbsize;
  padding-top: 16px;
  font-size: 40px;
  color: #EFEFEF;
}
.gd-library-item-thumbnail {
  max-width: $editor-library-item-thumbsize;
  max-height: $editor-library-item-thumbsize;
  overflow: clip;  
}

.gd-library-item-type-shape {
  border-left-color: $ordereditor-library-shape;
}
.gd-library-item-type-kit {
  border-left-color: $ordereditor-library-kit;
}
.gd-library-item-type-assembly {
  border-left-color: $ordereditor-library-assembly;
}
.gd-library-item-type-centerCutOut {
  border-left-color: $ordereditor-library-centerCutOut;
}
.gd-library-item-type-edgeCutOut {
  border-left-color: $ordereditor-library-edgeCutOut;
}
.gd-library-item-type-cornerCutOut {
  border-left-color: $ordereditor-library-cornerCutOut;
}
.gd-library-item-type-panelItem {
  border-left-color: $ordereditor-library-panelItem;
}
</style>

<script>
import _ from 'lodash'

export default {
  name: 'EditorLibraryItem',
  props: {
    libraryItemId: [Number, String],
    title: String,
    description: String,
    icon: String,
    iconClass: String,
    info: Object,
    labelList: Array,
    contactIdList: [Array,String],
    thumbnailData: String,
    itemType: String
  },
  computed: {
    linkedContactCount() {
      if(this.contactIdList == null)
        return 0
      if(_.isArray(this.contactIdList))
        return this.contactIdList.length
      return (this.contactIdList + '').split(',').length
    }
  },
  mounted() {
  },
  methods: {
    itemClicked(ev) {
      this.$emit('click', ev)
    }    
  }
}
</script>